// @ constants
const actionTypes = require('constants/actionTypes');
const { OPENYOUNG_MAX_CHILD_LIMIT } = require('constants/index');

// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const { sha256 } = require('utilities/hash');

// @actions
const { getChildDetails } = require('./openYoungDashboardChildDetails');

const getOpenYoungChildListRequest = () => ({
    type: actionTypes.OPENYOUNG_DASHBOARD_CHILD_LIST_REQUEST
});

const getOpenYoungChildListSuccess = openYoungChildList => ({
    type: actionTypes.OPENYOUNG_DASHBOARD_CHILD_LIST_SUCCESS,
    payload: {
        openYoungChildList
    }
});

const getOpenYoungChildListError = error => ({
    type: actionTypes.OPENYOUNG_DASHBOARD_CHILD_LIST_ERROR,
    payload: {
        error
    }
});

const getOpenYoungChildsAvatarRequest = () => ({
    type: actionTypes.OPENYOUNG_DASHBOARD_CHILD_AVATAR_REQUEST
});

const getOpenYoungChildsAvatarSuccess = openYoungChildsAvatarList => ({
    type: actionTypes.OPENYOUNG_DASHBOARD_CHILD_AVATAR_SUCCESS,
    payload: {
        openYoungChildsAvatarList
    }
});

const getOpenYoungChildsAvatarError = error => ({
    type: actionTypes.OPENYOUNG_DASHBOARD_CHILD_AVATAR_ERROR,
    payload: {
        error
    }
});

const getChildAvatars = childs => dispatch => {
    dispatch(getOpenYoungChildsAvatarRequest());
    const getAvatars = childs.map((child) => {
        const childKey = child.childKey;
        const sha256Code = !!childKey ? sha256(childKey) : '';

        return APIPost({
            dispatch,
            endpoint: 'openYoungKidsAvatars',
            params: {
                header: {
                    version: 2
                },
                query: {
                    userKey: sha256Code
                }
            }
        });
    });

    return Promise.all(getAvatars)
        .then(responses => {
            dispatch(getOpenYoungChildsAvatarSuccess(responses));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(getOpenYoungChildsAvatarError(response.error.description));
            } else {
                throw response;
            }
        });
};

const getChildList = data => (dispatch, getState) => {
    const immCardsById = getState().cards.get('byId');
    const immCardsByOrder = getState().cards.get('byOrder');
    const immAccountsById = getState().accounts.get('byId');
    const immAccountsByOrder = getState().accounts.get('byOrder');
    const accounts = immAccountsByOrder.map(accountId => {
        const immAccount = immAccountsById.get(accountId);
        return {
            contractNumber: immAccount.get('newContractNumber'),
            productSubtype: immAccount.get('accountType'),
            productType: immAccount.get('newProduct'),
        };
    });
    const cards = immCardsByOrder.map(cardId => {
        const immCard = immCardsById.get(cardId);
        return {
            contractNumber: immCard.getIn(['contract', 'number']),
            pan: immCard.get('number'),
            productSubtype: immCard.get('productSubType'),
            productType: immCard.get('newProduct'),
            standard: immCard.getIn(['product', 'standard']),
            status: immCard.get('statusCode'),
        };
    });

    dispatch(getOpenYoungChildListRequest());
    const params = {
        query: {
            accounts,
            cards
        }
    };

    return APIPost({
        dispatch,
        endpoint: 'openYoungKidsDashboard',
        params
    })
        .then(response => {
            if (!!response.childs) {
                let childResponse = response.childs || [];
                if (childResponse.length) {
                    if (childResponse.length > OPENYOUNG_MAX_CHILD_LIMIT) {
                        childResponse = childResponse.slice(0, OPENYOUNG_MAX_CHILD_LIMIT);
                    }
                    dispatch(getOpenYoungChildListSuccess(childResponse));
                    dispatch(getChildAvatars(childResponse));
                    !!childResponse[0].cards && dispatch(getChildDetails(childResponse[0].cards[0]));
                    if (data) {
                        data.successCallback && data.successCallback(childResponse);
                    }
                } else {
                    dispatch(getOpenYoungChildListError(''));
                }
            } else {
                dispatch(getOpenYoungChildListError(response.error.description));
                if (data) {
                    data.errorCallback && data.errorCallback(response.error);
                }
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(getOpenYoungChildListError(response.error.description));
            } else {
                throw response;
            }
        });
};

module.exports = {
    getChildList,
};
